import React from 'react';
import { Spinner } from 'reactstrap';
import * as pbi from 'powerbi-client';
import { fetchPBIEmbedUrl } from '../../actions/reports';

class PowerBIEmbed extends React.PureComponent {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(window.location.search);
    this.state = {
      ref: React.createRef(),
      reportId: params.get('rid'), // '51da3e79-58c8-4db1-9e7d-178b99ed31e5',
      groupId: params.get('gid'),
    };
  }

  componentDidMount() {
    const { reportId, ref } = this.state;
    let { groupId } = this.state;
    if (groupId === 'undefined') { groupId = null; }

    fetchPBIEmbedUrl(reportId, groupId).then(({ data }) => {
      window.powerbi.embed(ref.current, {
        type: 'report',
        tokenType: pbi.models.TokenType.Embed,
        accessToken: data,
        embedUrl: 'https://app.powerbi.com/reportEmbed',
        id: reportId,
      });
    }).catch(() => {});
  }

  render() {
    const { ref } = this.state;

    return (
      <main className="bg-white power-bi">
        <div id="powerbi-embed-div" ref={ref}>
          {/* NOTE: This spinner is automatically removed by the embed process. */}
          <div className="d-flex align-items-center justify-content-center h-100">
            <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
            <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
            <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
          </div>
        </div>
      </main>
    );
  }
}

export default PowerBIEmbed;
